var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sound-buttons",class:[
        _vm.missing ? 'missing' : '',
        _vm.muted ? 'off' : 'on',
        _vm.mobile ? 'mobile-viewer' : ''
    ],attrs:{"title":"Play/Pause Music"},on:{"click":function($event){return _vm.toggleMusic()}}},[_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"soundbars"},[_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div')])}]

export { render, staticRenderFns }